import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {environment} from "../../environments/environment";
import {TemplateInfo} from '@allaihealth/util';

/** Service that loads note templates for the given user */
@Injectable({
	providedIn: 'root'
})
export class TemplatesService {
	/** The loaded templates */
	private _templates:TemplateInfo[];

	constructor(private http:HttpClient) {
	}

	/** Resolver to get all appointments for the list if not already loaded */
	static resolveTemplates():Promise<TemplateInfo[]> {
		return inject(TemplatesService).loadTemplates();
	}

	/** Resolver to get all templates for this user */
	async loadTemplates():Promise<TemplateInfo[]> {
		if(!this._templates) {
			this._templates = await firstValueFrom(this.http.get<TemplateInfo[]>(`${environment.apiUrl}/templates`));
		}

		return this._templates;
	}

	/** The loaded templates */
	get templates():TemplateInfo[] {
		return this._templates;
	}
}
